/* tslint:disable */
/* eslint-disable */
/**
 * Invictus
 * Invictus Backend API
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, AxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError } from '../base';
// @ts-ignore
import { AuthenticateApplyRequest } from '../model';
// @ts-ignore
import { AuthenticateRefreshRequest } from '../model';
// @ts-ignore
import { AuthenticateUpdateRequest } from '../model';
// @ts-ignore
import { AuthenticateUpdateResponse } from '../model';
// @ts-ignore
import { OutputErrorMessage } from '../model';
// @ts-ignore
import { UserAccountFound } from '../model';
/**
 * AuthenticationControllerV2Api - axios parameter creator
 * @export
 */
export const AuthenticationControllerV2ApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} xBffKey bff key header
         * @param {AuthenticateApplyRequest} authenticateApplyRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        authenticateApply: async (xBffKey: string, authenticateApplyRequest: AuthenticateApplyRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'xBffKey' is not null or undefined
            assertParamExists('authenticateApply', 'xBffKey', xBffKey)
            // verify required parameter 'authenticateApplyRequest' is not null or undefined
            assertParamExists('authenticateApply', 'authenticateApplyRequest', authenticateApplyRequest)
            const localVarPath = `/api/v2/authenticate/apply`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (xBffKey != null) {
                localVarHeaderParameter['x-bff-key'] = String(xBffKey);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(authenticateApplyRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} xBffKey bff key header
         * @param {AuthenticateRefreshRequest} authenticateRefreshRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        authenticateRefresh: async (xBffKey: string, authenticateRefreshRequest: AuthenticateRefreshRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'xBffKey' is not null or undefined
            assertParamExists('authenticateRefresh', 'xBffKey', xBffKey)
            // verify required parameter 'authenticateRefreshRequest' is not null or undefined
            assertParamExists('authenticateRefresh', 'authenticateRefreshRequest', authenticateRefreshRequest)
            const localVarPath = `/api/v2/authenticate/refresh`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (xBffKey != null) {
                localVarHeaderParameter['x-bff-key'] = String(xBffKey);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(authenticateRefreshRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} code 
         * @param {string} state 
         * @param {string} xBffKey bff key header
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        authenticationRedirect: async (code: string, state: string, xBffKey: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'code' is not null or undefined
            assertParamExists('authenticationRedirect', 'code', code)
            // verify required parameter 'state' is not null or undefined
            assertParamExists('authenticationRedirect', 'state', state)
            // verify required parameter 'xBffKey' is not null or undefined
            assertParamExists('authenticationRedirect', 'xBffKey', xBffKey)
            const localVarPath = `/api/v2/authenticated-redirect`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (code !== undefined) {
                localVarQueryParameter['code'] = code;
            }

            if (state !== undefined) {
                localVarQueryParameter['state'] = state;
            }

            if (xBffKey != null) {
                localVarHeaderParameter['x-bff-key'] = String(xBffKey);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} redirectUri 
         * @param {string} xBffKey bff key header
         * @param {string} [idToken] 
         * @param {string} [channel] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        logout: async (redirectUri: string, xBffKey: string, idToken?: string, channel?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'redirectUri' is not null or undefined
            assertParamExists('logout', 'redirectUri', redirectUri)
            // verify required parameter 'xBffKey' is not null or undefined
            assertParamExists('logout', 'xBffKey', xBffKey)
            const localVarPath = `/api/v2/authenticate/logout`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (idToken !== undefined) {
                localVarQueryParameter['idToken'] = idToken;
            }

            if (redirectUri !== undefined) {
                localVarQueryParameter['redirectUri'] = redirectUri;
            }

            if (channel !== undefined) {
                localVarQueryParameter['channel'] = channel;
            }

            if (xBffKey != null) {
                localVarHeaderParameter['x-bff-key'] = String(xBffKey);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} state 
         * @param {string} xBffKey bff key header
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postLogoutRedirect: async (state: string, xBffKey: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'state' is not null or undefined
            assertParamExists('postLogoutRedirect', 'state', state)
            // verify required parameter 'xBffKey' is not null or undefined
            assertParamExists('postLogoutRedirect', 'xBffKey', xBffKey)
            const localVarPath = `/api/v2/post-logout-redirect`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (state !== undefined) {
                localVarQueryParameter['state'] = state;
            }

            if (xBffKey != null) {
                localVarHeaderParameter['x-bff-key'] = String(xBffKey);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} xBffKey bff key header
         * @param {string} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        revokeToken: async (xBffKey: string, body: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'xBffKey' is not null or undefined
            assertParamExists('revokeToken', 'xBffKey', xBffKey)
            // verify required parameter 'body' is not null or undefined
            assertParamExists('revokeToken', 'body', body)
            const localVarPath = `/api/v2/revoke`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (xBffKey != null) {
                localVarHeaderParameter['x-bff-key'] = String(xBffKey);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} xBffKey bff key header
         * @param {string} [error] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        selfServiceRedirect: async (xBffKey: string, error?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'xBffKey' is not null or undefined
            assertParamExists('selfServiceRedirect', 'xBffKey', xBffKey)
            const localVarPath = `/api/v2/self-service-redirect`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (error !== undefined) {
                localVarQueryParameter['error'] = error;
            }

            if (xBffKey != null) {
                localVarHeaderParameter['x-bff-key'] = String(xBffKey);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} action 
         * @param {string} xBffKey bff key header
         * @param {AuthenticateUpdateRequest} authenticateUpdateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        startUpdateAccount: async (action: string, xBffKey: string, authenticateUpdateRequest: AuthenticateUpdateRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'action' is not null or undefined
            assertParamExists('startUpdateAccount', 'action', action)
            // verify required parameter 'xBffKey' is not null or undefined
            assertParamExists('startUpdateAccount', 'xBffKey', xBffKey)
            // verify required parameter 'authenticateUpdateRequest' is not null or undefined
            assertParamExists('startUpdateAccount', 'authenticateUpdateRequest', authenticateUpdateRequest)
            const localVarPath = `/api/v2/authenticate/update/{action}`
                .replace(`{${"action"}}`, encodeURIComponent(String(action)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (xBffKey != null) {
                localVarHeaderParameter['x-bff-key'] = String(xBffKey);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(authenticateUpdateRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} xBffKey bff key header
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        webLogoutRedirect: async (xBffKey: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'xBffKey' is not null or undefined
            assertParamExists('webLogoutRedirect', 'xBffKey', xBffKey)
            const localVarPath = `/api/v2/web-logout-redirect`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (xBffKey != null) {
                localVarHeaderParameter['x-bff-key'] = String(xBffKey);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AuthenticationControllerV2Api - functional programming interface
 * @export
 */
export const AuthenticationControllerV2ApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = AuthenticationControllerV2ApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} xBffKey bff key header
         * @param {AuthenticateApplyRequest} authenticateApplyRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async authenticateApply(xBffKey: string, authenticateApplyRequest: AuthenticateApplyRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UserAccountFound>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.authenticateApply(xBffKey, authenticateApplyRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} xBffKey bff key header
         * @param {AuthenticateRefreshRequest} authenticateRefreshRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async authenticateRefresh(xBffKey: string, authenticateRefreshRequest: AuthenticateRefreshRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UserAccountFound>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.authenticateRefresh(xBffKey, authenticateRefreshRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} code 
         * @param {string} state 
         * @param {string} xBffKey bff key header
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async authenticationRedirect(code: string, state: string, xBffKey: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.authenticationRedirect(code, state, xBffKey, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} redirectUri 
         * @param {string} xBffKey bff key header
         * @param {string} [idToken] 
         * @param {string} [channel] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async logout(redirectUri: string, xBffKey: string, idToken?: string, channel?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.logout(redirectUri, xBffKey, idToken, channel, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} state 
         * @param {string} xBffKey bff key header
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async postLogoutRedirect(state: string, xBffKey: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.postLogoutRedirect(state, xBffKey, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} xBffKey bff key header
         * @param {string} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async revokeToken(xBffKey: string, body: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.revokeToken(xBffKey, body, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} xBffKey bff key header
         * @param {string} [error] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async selfServiceRedirect(xBffKey: string, error?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.selfServiceRedirect(xBffKey, error, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} action 
         * @param {string} xBffKey bff key header
         * @param {AuthenticateUpdateRequest} authenticateUpdateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async startUpdateAccount(action: string, xBffKey: string, authenticateUpdateRequest: AuthenticateUpdateRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AuthenticateUpdateResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.startUpdateAccount(action, xBffKey, authenticateUpdateRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} xBffKey bff key header
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async webLogoutRedirect(xBffKey: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.webLogoutRedirect(xBffKey, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * AuthenticationControllerV2Api - factory interface
 * @export
 */
export const AuthenticationControllerV2ApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = AuthenticationControllerV2ApiFp(configuration)
    return {
        /**
         * 
         * @param {string} xBffKey bff key header
         * @param {AuthenticateApplyRequest} authenticateApplyRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        authenticateApply(xBffKey: string, authenticateApplyRequest: AuthenticateApplyRequest, options?: any): AxiosPromise<UserAccountFound> {
            return localVarFp.authenticateApply(xBffKey, authenticateApplyRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} xBffKey bff key header
         * @param {AuthenticateRefreshRequest} authenticateRefreshRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        authenticateRefresh(xBffKey: string, authenticateRefreshRequest: AuthenticateRefreshRequest, options?: any): AxiosPromise<UserAccountFound> {
            return localVarFp.authenticateRefresh(xBffKey, authenticateRefreshRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} code 
         * @param {string} state 
         * @param {string} xBffKey bff key header
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        authenticationRedirect(code: string, state: string, xBffKey: string, options?: any): AxiosPromise<object> {
            return localVarFp.authenticationRedirect(code, state, xBffKey, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} redirectUri 
         * @param {string} xBffKey bff key header
         * @param {string} [idToken] 
         * @param {string} [channel] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        logout(redirectUri: string, xBffKey: string, idToken?: string, channel?: string, options?: any): AxiosPromise<object> {
            return localVarFp.logout(redirectUri, xBffKey, idToken, channel, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} state 
         * @param {string} xBffKey bff key header
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postLogoutRedirect(state: string, xBffKey: string, options?: any): AxiosPromise<object> {
            return localVarFp.postLogoutRedirect(state, xBffKey, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} xBffKey bff key header
         * @param {string} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        revokeToken(xBffKey: string, body: string, options?: any): AxiosPromise<object> {
            return localVarFp.revokeToken(xBffKey, body, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} xBffKey bff key header
         * @param {string} [error] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        selfServiceRedirect(xBffKey: string, error?: string, options?: any): AxiosPromise<object> {
            return localVarFp.selfServiceRedirect(xBffKey, error, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} action 
         * @param {string} xBffKey bff key header
         * @param {AuthenticateUpdateRequest} authenticateUpdateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        startUpdateAccount(action: string, xBffKey: string, authenticateUpdateRequest: AuthenticateUpdateRequest, options?: any): AxiosPromise<AuthenticateUpdateResponse> {
            return localVarFp.startUpdateAccount(action, xBffKey, authenticateUpdateRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} xBffKey bff key header
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        webLogoutRedirect(xBffKey: string, options?: any): AxiosPromise<object> {
            return localVarFp.webLogoutRedirect(xBffKey, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * AuthenticationControllerV2Api - object-oriented interface
 * @export
 * @class AuthenticationControllerV2Api
 * @extends {BaseAPI}
 */
export class AuthenticationControllerV2Api extends BaseAPI {
    /**
     * 
     * @param {string} xBffKey bff key header
     * @param {AuthenticateApplyRequest} authenticateApplyRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthenticationControllerV2Api
     */
    public authenticateApply(xBffKey: string, authenticateApplyRequest: AuthenticateApplyRequest, options?: AxiosRequestConfig) {
        return AuthenticationControllerV2ApiFp(this.configuration).authenticateApply(xBffKey, authenticateApplyRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} xBffKey bff key header
     * @param {AuthenticateRefreshRequest} authenticateRefreshRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthenticationControllerV2Api
     */
    public authenticateRefresh(xBffKey: string, authenticateRefreshRequest: AuthenticateRefreshRequest, options?: AxiosRequestConfig) {
        return AuthenticationControllerV2ApiFp(this.configuration).authenticateRefresh(xBffKey, authenticateRefreshRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} code 
     * @param {string} state 
     * @param {string} xBffKey bff key header
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthenticationControllerV2Api
     */
    public authenticationRedirect(code: string, state: string, xBffKey: string, options?: AxiosRequestConfig) {
        return AuthenticationControllerV2ApiFp(this.configuration).authenticationRedirect(code, state, xBffKey, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} redirectUri 
     * @param {string} xBffKey bff key header
     * @param {string} [idToken] 
     * @param {string} [channel] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthenticationControllerV2Api
     */
    public logout(redirectUri: string, xBffKey: string, idToken?: string, channel?: string, options?: AxiosRequestConfig) {
        return AuthenticationControllerV2ApiFp(this.configuration).logout(redirectUri, xBffKey, idToken, channel, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} state 
     * @param {string} xBffKey bff key header
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthenticationControllerV2Api
     */
    public postLogoutRedirect(state: string, xBffKey: string, options?: AxiosRequestConfig) {
        return AuthenticationControllerV2ApiFp(this.configuration).postLogoutRedirect(state, xBffKey, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} xBffKey bff key header
     * @param {string} body 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthenticationControllerV2Api
     */
    public revokeToken(xBffKey: string, body: string, options?: AxiosRequestConfig) {
        return AuthenticationControllerV2ApiFp(this.configuration).revokeToken(xBffKey, body, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} xBffKey bff key header
     * @param {string} [error] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthenticationControllerV2Api
     */
    public selfServiceRedirect(xBffKey: string, error?: string, options?: AxiosRequestConfig) {
        return AuthenticationControllerV2ApiFp(this.configuration).selfServiceRedirect(xBffKey, error, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} action 
     * @param {string} xBffKey bff key header
     * @param {AuthenticateUpdateRequest} authenticateUpdateRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthenticationControllerV2Api
     */
    public startUpdateAccount(action: string, xBffKey: string, authenticateUpdateRequest: AuthenticateUpdateRequest, options?: AxiosRequestConfig) {
        return AuthenticationControllerV2ApiFp(this.configuration).startUpdateAccount(action, xBffKey, authenticateUpdateRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} xBffKey bff key header
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthenticationControllerV2Api
     */
    public webLogoutRedirect(xBffKey: string, options?: AxiosRequestConfig) {
        return AuthenticationControllerV2ApiFp(this.configuration).webLogoutRedirect(xBffKey, options).then((request) => request(this.axios, this.basePath));
    }
}
